/**
 * Interruptor de la plantilla V2 de la página de tour.
 *
 * Reglas (acordadas con el cliente):
 *  - Solo se activa para los slugs de la lista blanca (arranca con Holbox Express).
 *  - Solo en vista previa / desarrollo, o añadiendo `?v2=1` a la URL.
 *  - `?v2=0` fuerza la plantilla actual siempre.
 *  - En producción la plantilla actual sigue siendo la predeterminada.
 *
 * El checkout propio Bókun + Stripe es un interruptor INDEPENDIENTE
 * (`TOUR_V2_OWN_CHECKOUT`), apagado por defecto y pensado para activarse
 * más adelante tour por tour sin volver a tocar el diseño.
 */

/** Slugs con la plantilla V2 habilitada. */
export const TOUR_V2_SLUGS: readonly string[] = ["tour-a-holbox-express-1237871"];

/** Vista previa / desarrollo, o build con la bandera encendida. */
const PREVIEW_DEFAULT_ON =
  import.meta.env.DEV || import.meta.env["VITE_TOUR_V2_ENABLED"] === "true";

/** Checkout propio (Bókun + Stripe): solo sandbox, apagado por defecto. */
export const TOUR_V2_OWN_CHECKOUT = import.meta.env["VITE_TOUR_V2_OWN_CHECKOUT"] === "true";

export function isTourV2Slug(slug: string): boolean {
  return TOUR_V2_SLUGS.includes(slug);
}

/**
 * INTERRUPTOR DE REVERSIÓN. `true` = V2 para todas las páginas `/tour/...`
 * (aprobado para producción). Cambiar a `false` y volver a publicar regresa
 * inmediatamente a la plantilla anterior en todo el catálogo.
 * `?v2=0` fuerza la anterior y `?v2=1` fuerza la V2 en cualquier caso.
 */
export const TOUR_V2_DEFAULT_ON = true;

/**
 * Decide si se debe renderizar la V2. `searchV2` es el valor crudo del
 * parámetro `v2` (`"1"` / `"0"` / undefined) y se resuelve igual en el
 * servidor y en el cliente para no provocar diferencias de hidratación.
 */
export function resolveTourV2({
  slug,
  searchV2,
}: {
  slug: string;
  searchV2?: string | null;
}): boolean {
  void slug;
  void PREVIEW_DEFAULT_ON;
  if (searchV2 === "1") return true;
  if (searchV2 === "0") return false;
  return TOUR_V2_DEFAULT_ON;
}
